import { Component, Input } from "@angular/core"
import { ModalRef } from "../../../shared-components/modal/modal-ref"
import { ModalService } from "../../../shared-components/modal/modal.service"
import { AuthModalComponent } from "../../../shared-components/modals/auth-modal/auth-modal.component"
import { UserService } from "../../../services/user.service"
import { LTIMedia } from "../../../models/resource/media"
import { StudentSignInModalComponent } from "../../../shared-components/modals/student-sign-in-modal/student-sign-in-modal.component"
import { AssetOpenMode } from "../../../models/resource/asset"
import { InteractivePreviewModalComponent } from "../interactive-preview-modal/interactive-preview-modal.component"

@Component({
    selector: "app-continue-modal",
    templateUrl: "./lti-continue-modal.component.html",
    styleUrls: ["./lti-continue-modal.component.scss"],
    standalone: false,
})
export class LtiContinueModalComponent {
    @Input() public ltiMedia: LTIMedia
    @Input() public openMode: AssetOpenMode

    constructor(
        public activeModal: ModalRef,
        public userService: UserService,
        private modalService: ModalService
    ) {}

    public openLTILoginModal() {
        this.activeModal.close()
        if (this.userService.hasStudentExperience()) {
            this.modalService.open(StudentSignInModalComponent)
        } else {
            this.modalService.open(AuthModalComponent, {
                data: {
                    description:
                        "Log in to PBS LearningMedia to unlock interactive lessons and " +
                        "tons of other features to bring your classroom to life",
                },
            })
        }
    }

    private openFullWindowExperience(): void {
        this.modalService.open(InteractivePreviewModalComponent, {
            data: {
                interactiveMedia: this.ltiMedia,
            },
        })
    }

    public goToLTIAsGuest() {
        this.activeModal.close()
        if (this.openMode === AssetOpenMode.IFRAME) {
            this.openFullWindowExperience()
        } else {
            window.open(this.ltiMedia.getGuestURL(window.location.href), "_blank")
        }
    }
}
